import {
	type NavigateOptions,
	Outlet,
	type ToOptions,
	createRouter as createTanStackRouter,
} from "@tanstack/react-router";
import { routerWithQueryClient } from "@tanstack/react-router-with-query";

import { ErrorBoundary, NotFoundPage } from "@onesolution/components";
import queryClient from "./components/ProvidersWrapper/queryClient";
import { routeTree } from "./routeTree.gen";
export function createRouter() {
	const router = createTanStackRouter({
		routeTree,
		context: {
			queryClient,
		},
		scrollRestoration: true,
		defaultPreload: "intent",
		defaultErrorComponent: (props) => <ErrorBoundary {...props} />,
		defaultNotFoundComponent: (props) => <NotFoundPage {...props} />,
		// TODO: change to a global loader with a suspense fallback on the main layout
		defaultPendingComponent: () => <Outlet />,
		defaultViewTransition: true,
	});

	return routerWithQueryClient(router, queryClient);
}

declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof createRouter>;
	}
}

declare module "@react-types/shared" {
	interface RouterConfig {
		href: ToOptions["to"];
		routerOptions: Omit<NavigateOptions, keyof ToOptions>;
	}
}
